class SectionPressFeature extends HTMLElement {
  constructor() {
    super();
    this.carousel = this.querySelector("[data-carousel]");
    this.init();
  }

  init() {
    this.initCarousel();
  }

  initCarousel() {
    const splide = new Splide( this.carousel, {
      type   : 'loop',
      drag   : 'free',
      focus  : 'center',
      perPage: 5,
      gap : 80,
      autoScroll: {
        speed: 1,
      },
      lazyLoad : 'nearby',
      arrows : false,
      pagination : false,
      autoWidth: true,
      breakpoints: {
        1024: {
          perPage: 4,
          gap : 40,
        },
        640: {
          perPage: 3,
          gap : 30,
        },
        320: {
          perPage: 2.5,
          gap : 30,
        },
      },
    } );
    
    splide.mount(window.splide.Extensions);
  }
}

if (!customElements.get("section-press-feature")) {
  customElements.define("section-press-feature", SectionPressFeature);
}
